export enum MediaTypeOption {
  NONE = '',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio'
}
